export {data};

import {render} from 'vike/abort';
import API_URL from '../../includes/api.js';
import {resolveTenantData} from '../../tenant/site-configs.js';
import {fetchApiJson, refererHeaders} from '../../includes/server-fetch.js';

// Mirrors Song.jsx's anonymous getSong() so <Helmet> isn't empty during SSR (client fetch runs in a useEffect, which SSR skips).
// Deliberately unauthenticated: SSR has no session, but that's also what crawlers/link-preview bots see.
//
// +data.shared.js is NOT cumulative in Vike — this file fully replaces the root +data.shared.js.
// Must resolve+spread tenant data itself or this page loses messages/faq/about.
async function data(pageContext) {
    const tenantData = resolveTenantData(pageContext);
    const search = pageContext.urlParsed?.search ?? {};
    const s = search.s ?? '';
    const p = search.p ?? '';

    // No song id: a real 404, as the PHP layer used to send.
    if (!s) throw render(404);

    if (!import.meta.env.SSR) return {...tenantData, song: null};

    // Custom and favourite playlists need the visitor's Firebase token, which
    // SSR doesn't have; the page fetches those itself after hydration.
    if (p.includes('custom-') || p.includes('favorite')) {
        return {...tenantData, song: null};
    }

    let params = 's=' + encodeURIComponent(s);
    if (p) params += '&p=' + encodeURIComponent(p);
    params += '&explore=true';

    const result = await fetchApiJson(`${API_URL}/song/get?${params}`, refererHeaders(pageContext), pageContext);

    // The API answered that this song (or this song in this playlist) doesn't
    // exist: send a real 404 status instead of a 200 with a not-found body,
    // so crawlers and the CDN treat it as missing. Anything else non-ok
    // (API unreachable, 5xx, rate-limited) leaves song null and the page's
    // client-side fetch retries; it must not look like a 404.
    if (result.code === 404) throw render(404);

    return {...tenantData, song: result.ok ? result.data : null};
}
